import { useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { useActivation, useScopedViewModel } from '@/hooks/view-model-hooks'
import { useFeatures } from '@/contexts/root-store-context'
import { useObservable } from '@/hooks/rx-hooks'
import { links } from '@/utils/link'
import { ConfirmEmailView } from '@/features/email-confirmation/ConfirmEmailView'
import { ConfirmEmailViewModel } from './ConfirmEmailViewModel'

export default observer(function ConfirmEmailViewContainer() {
  const vm = useScopedViewModel(
    ({ shell }) => new ConfirmEmailViewModel(shell.newAlert),
  )
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useObservable(vm.navigateToEmailConfirmed$, () =>
    navigate(links.emailConfirmed(), { replace: true }),
  )

  const token = searchParams.get('session_token') ?? ''
  useActivation(
    vm,
    useCallback((v) => v.activate(token), [token]),
  )

  return (
    <ConfirmEmailView
      pageExpired={vm.pageExpired}
      email={vm.email}
      onResendVerificationEmail={vm.resendVerificationEmail}
      logoPrimary={shellInfo.logoUrl}
      landingPageImage={shellInfo.landingPageImageUrl}
    />
  )
})
